import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, TextField, Grid, Paper, CircularProgress } from '@material-ui/core'
import { useForm, Controller } from "react-hook-form";
import DownloadIcon from '@material-ui/icons/SaveAlt';
import SearchIcon from '@material-ui/icons/Search';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { NotificationActions, PointAggregateActions } from '../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        fontSize: '18px',
    },
    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 0 auto'
        }
    },
    amount: {
        fontSize: '14px',
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const pointAggregateSelector = (state) => state.PointAggregates;
const IdentitySelector = (state) => state.Identity;

const PointAggregate = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const pointAggregateActions = bindActionCreators(PointAggregateActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { list, nowWainting } = useSelector(pointAggregateSelector);
    const { token } = useSelector(IdentitySelector);

    // React Hook Form
    const { control } = useForm();

    const { classes } = props;

    // 一覧タイトル用
    const [searchDateTitle, setSearchDateTitle] = useState();

    const listDefinition = {
        columns: [
            {
                // 加盟店名
                title: <FormattedMessage id="Merchant.Name" />,
                field: 'merchant_name',
                filtering: true,
            },
            {
                // ポイント集計表
                title: <FormattedMessage id="PointAggregate.PointAggregateList" />,
                field: 'point_document',
                filtering: false,
                render: rowData => {
                    return (
                        <div>
                            <Button onClick={() => onDownloadClick(rowData)} variant="contained" color="secondary" size="small" endIcon={<DownloadIcon />}>
                                <FormattedMessage id="Button.Download" />
                            </Button>
                        </div>
                    )
                }
            },
        ]
    };

    /**
     *
     * 検索ボタン押下時の処理
     *
     */
    const onSearchClick = () => {
        // 検索年月をAPI用に yyyy/mm/dd形式に変換
        var yyyy = searchDate.slice(0, 4);
        var mm = searchDate.slice(-2);
        var searchDt = yyyy + '/' + mm + '/01';
        // ポイント集計情報リストを取得
        pointAggregateActions.listPointAggregates(token, searchDt)
            .then(data => {
                var title = yyyy + '年' + mm + '月';
                setSearchDateTitle(title);
                if (data.length == 0) {
                    notificationActions.showInfo("検索条件に該当するレコードがありません。");
                }
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * ポイント集計表ダウンロード押下時の処理
     *
     */
    const onDownloadClick = (rowData) => {
        // ダウンロードファイル名生成
        const fileName = `ポイント集計表_${rowData.merchant_name}_${searchDateTitle}.pdf`;

        // PDFファイルデータ（base64エンコードされた文字列形式で渡される）
        var b64Data = rowData.point_document;
        // base64でエンコードされた文字列をバイナリデータの各バイトの文字を持つ新しい文字列にデコード
        const byteCharacters = atob(b64Data);
        // デコードした文字列をバイト値の配列に変換
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        // Blobに変換
        const contentType = 'application/pdf';
        const blob = new Blob([byteArray], { type: contentType });

        // ダウンロード用URL作成
        let url = (window.URL || window.webkitURL).createObjectURL(blob);
        // アンカータグを作成
        let link = document.createElement('a');
        link.download = fileName;
        link.href = url;
        document.body.appendChild(link);
        // クリックイベントを発生させる（ダウンロード）
        link.click();
        document.body.removeChild(link);
        // メッセージ表示
        notificationActions.showSuccess(`ダウンロードしました。（${fileName}）`);
    }

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const { name, value } = e[0].target;

        if (name.startsWith('nengestu')) {
            setSearchDate(value);
        }

        return value;
    }

    /**
     *
     * 初期表示処理
     * 
     */
    useEffect(() => {
        // 一覧を初期化
        pointAggregateActions.initListInfo();
    }, []);

    var dt = new Date();
    var defaultValue = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2);
    const [searchDate, setSearchDate] = useState(defaultValue);

    const placeholder = <FormattedMessage id="Table.Action" />;

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <div className={classes.infoTitle}>
                                <Typography id="infoTitle" component="h2" variant="inherit"><FormattedMessage id="PointAggregate.Title" /></Typography>
                                <div>
                                    <Button fullWidth id="searchButton" variant="contained" size="medium" color="primary"
                                        startIcon={<SearchIcon />}
                                        onClick={onSearchClick}><FormattedMessage id="Button.Search" /></Button>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Controller
                                name="nengestu"
                                control={control}
                                onChange={onChange}
                                defaultValue={defaultValue}
                                as={<TextField fullWidth variant="outlined"
                                    id="nengestu"
                                    label={<FormattedMessage id={"PointAggregate.YearAndMonth"} />}
                                    type="month"
                                    className={classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />}
                            />
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            <MaterialTable
                title={<Typography component="h2" variant="inherit">{searchDateTitle}</Typography>}
                columns={listDefinition.columns}
                data={list}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1,
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    Action: actionProps => {
                        return (
                            <div></div>
                        )
                    },
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(PointAggregate);
